import * as d3 from "d3";
import * as points from "./models/points.js";
import * as scatterplot from "./plots/scatterplot.js";
import * as barcodeplot from "./plots/barcodeplot.js";
import * as lineplot from "./plots/lineplot.js";
import * as columnplot from "./plots/columnplot.js";

export function launch(userInput, gene){

    clear()
    $(".custom-pill").html(`x ${gene}`).removeClass("hidden")

    let baseUrl = "https://tide-data-server.uc.r.appspot.com/";
    let dependencyURl = `${baseUrl}dependency?g=${gene}&c=${userInput.c}&l=${userInput.l}&scatter=${userInput.scatter}`;
    let guideDensityURl = `${baseUrl}density?g=${gene}&c=${userInput.c}&l=${userInput.l}`;
    let guidePerformanceURl = `${baseUrl}guide_performance?g=${gene}&l=${userInput.l}`;
    let rnaSeqURl = `${baseUrl}rnaseq?g=${gene}`;
  
    Promise.all([    
        $.getJSON(dependencyURl, result=> result),
        $.getJSON(guideDensityURl, result=> result),
        $.getJSON(guidePerformanceURl, result=> result),
        $.getJSON(rnaSeqURl, result=> result)
    ])
    .then((result)=>{
        let scatterplotData = points.createVolcanoPoints(result[0])
        let barcodeplotData = points.createBarcodePoints(result[1])
        let lineplotData = points.createLinePoints(result[2])
        let columnplotData = points.createColumnPoints(result[3])

        barcodeplot.render(barcodeplotData)
        scatterplot.render(scatterplotData)
        lineplot.render(lineplotData)
        columnplot.render(columnplotData)

        d3.selectAll(".ljs--lattice-plot").selectAll(".domain").remove()
    })
 }

 export function clear(){
    barcodeplot.clear()
    scatterplot.clear()
    lineplot.clear()
    columnplot.clear()
}

